import {Injectable} from "@angular/core";
import {SideNav} from "./entity/base.entity";

@Injectable({
  providedIn: 'root'
})
export class BaseRepository {
  private _urls: SideNav[] = [
    {route: '/dashboard', icon: 'bar-chart-ic', text: 'Dashboard'},
    {route: '/configuration', icon: 'settings-ic', text: 'Configuration'},
    {route: '/report', icon: 'pie-chart-ic', text: 'Reports'},
    {route: '/user', icon: 'users-ic', text: 'Users'},
    {route: '/menu', icon: 'fork-knife-ic', text: 'Menu'},
    {route: '/reward', icon: 'reward-ic', text: 'Reward'},
  ];

  constructor() {
  }

  getSideNav(): SideNav[] {
    return this._urls;
  }
}
